import { c as _c } from "react/compiler-runtime";
import { PINNED_RIGHT_EDGE_LINE_STYLE, ROW_BORDER_BOTTOM } from '../../constants/borderStyles';
import { DEFAULT_COL_WIDTH } from '../../constants/defaultColWidth';
import type { EagColumnState } from '../../types/EagColumnState';
export type SkeletonRowProps = {
  heightPx: number;
  columnStates: EagColumnState[];
  horizontalSeparators: boolean;
  actionColumnWidth?: number;
};
export function SkeletonRow(props) {
  const $ = _c(15);
  const t0 = props.horizontalSeparators ? ROW_BORDER_BOTTOM : undefined;
  let t1;
  if ($[0] !== props.heightPx || $[1] !== t0) {
    t1 = {
      height: props.heightPx,
      ...t0
    };
    $[0] = props.heightPx;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.columnStates) {
    t2 = props.columnStates.filter(_temp).map(_temp2);
    $[3] = props.columnStates;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <td />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.columnStates) {
    t4 = props.columnStates.filter(_temp3).map(_temp4);
    $[6] = props.columnStates;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.actionColumnWidth) {
    t5 = props.actionColumnWidth ? <td style={{
      position: "sticky" as const,
      right: 0,
      zIndex: "var(--z-sidebar)",
      width: props.actionColumnWidth,
      maxWidth: props.actionColumnWidth
    }} className="p-0 border-0 bg-white"><span style={PINNED_RIGHT_EDGE_LINE_STYLE} /></td> : null;
    $[8] = props.actionColumnWidth;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <tr style={t1}>{t2}{t3}{t4}{t5}</tr>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp4(colState_0) {
  const width_0 = colState_0.width ?? DEFAULT_COL_WIDTH;
  return <td key={colState_0.key} className="p-2 border-0" style={{
    width: width_0,
    maxWidth: width_0
  }}><div className="animate-pulse bg-gray-200 h-4 rounded w-full" /></td>;
}
function _temp3(cs_0) {
  return cs_0.pinned === "RIGHT";
}
function _temp2(colState) {
  const width = colState.width ?? DEFAULT_COL_WIDTH;
  return <td key={colState.key} className="p-2 border-0" style={{
    width,
    maxWidth: width
  }}><div className="animate-pulse bg-gray-200 h-4 rounded w-full" /></td>;
}
function _temp(cs) {
  return cs.pinned !== "RIGHT";
}